import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("明细")
const _hoisted_2 = { class: "d-flex d-flex-row-reverse" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("明细")
const _hoisted_4 = { class: "d-flex d-flex-row-reverse" }

import Api from "@/http/modules";
import tbMix from "@/global_mixin/tableMixin";
import {onBeforeMount, ref, watch} from "vue";
import {
  fixed_asset_change_type_ly,
  fixed_asset_change_type_rk,
  type_consumables, type_fixed
} from "@/views/ViewsComponents/officeAssets/OfficeAssetUtils";


export default /*#__PURE__*/_defineComponent({
  props: {
    changeCount: null,
    searchObj: null
  },
  emits: ["changeRecordDetail"],
  setup(__props: any, { emit }) {

const props = __props as {
  changeCount: number,
  searchObj: {
    orgId: null | number,
    companyId: null | number,
    date: string[],
  }
}

const {
  "POST/office/asset/change_records": changeRecordsApi
} = Api

const activeTable = ref(fixed_asset_change_type_ly)
const tabMaxHeight = ref("520px")

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(changeRecordsApi)

onBeforeMount(() => {
  fetchData({type: type_consumables, changeType: activeTable.value})
})
watch(activeTable, (cur, old) => {
  page.value = 1;
  fetchData({type: type_consumables, changeType: cur,})
})

watch(()=>props.changeCount,(cur,old)=>{
  fetchData({type: type_consumables, changeType: activeTable.value})
})
watch(()=>props.searchObj,(n,o)=>{
  page.value = 1;
  if(n.date.length==2){
    fetchData({type: type_consumables, changeType: activeTable.value,orgId:n.orgId,companyId:n.companyId,start:n.date[0],end:n.date[1]})
  }else{
    fetchData({type: type_consumables, changeType: activeTable.value,orgId:n.orgId,companyId:n.companyId,start:null,end:null})
  }
})

const recordDetail = (record: any,changeType:string) => {
  emit("changeRecordDetail", {record: record, type: type_consumables,changeType:changeType})
}


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, {
      "tab-position": "left",
      style: {"height":"600px"},
      modelValue: activeTable.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeTable).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "领用记录",
          name: _unref(fixed_asset_change_type_ly)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                ref: "consumablesAssetLyTbEle",
                border: "",
                class: "mt-10",
                data: _unref(MI_tableData),
                "row-key": "id",
                "max-height": tabMaxHeight.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "耗材变动单号",
                    prop: "no",
                    "min-width": "210",
                    fixed: ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "变动类型",
                    prop: "typeDesc",
                    "min-width": "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "耗材名称",
                    prop: "changeAssetNames",
                    "min-width": "120",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "领用日期",
                    prop: "changeDate",
                    "min-width": "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "领用人",
                    prop: "ownerUserName",
                    "min-width": "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "领用数量",
                    prop: "count",
                    "min-width": "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "经办人",
                    prop: "operatorUserName",
                    "min-width": "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "备注",
                    prop: "备注",
                    "min-width": "120"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "操作",
                    fixed: "right",
                    "min-width": "120"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_link, {
                            type: "primary",
                            onClick: ($event: any) => (recordDetail(row,_unref(fixed_asset_change_type_ly)))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "max-height"])), [
                [_directive_loading, _unref(MI_identify)]
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_pagination, {
                  disabled: _unref(MI_identify),
                  background: "",
                  small: "",
                  total: _unref(MI_total),
                  currentPage: _unref(page),
                  "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
                  "page-size": _unref(size),
                  "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
                  class: "mt-10",
                  "page-sizes": [10, 30, 50, 100, 300, 1000],
                  layout: "sizes, prev, pager, next, total, jumper",
                  onCurrentChange: _unref(MI_pageChange),
                  onSizeChange: _unref(MI_sizeChange)
                }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["name"]),
        _createVNode(_component_el_tab_pane, {
          label: "入库记录",
          name: _unref(fixed_asset_change_type_rk),
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                ref: "consumablesAssetRkTbEle",
                border: "",
                class: "mt-10",
                data: _unref(MI_tableData),
                "row-key": "id",
                "max-height": tabMaxHeight.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "耗材变动单号",
                    prop: "no",
                    "min-width": "210",
                    fixed: ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "变动类型",
                    prop: "typeDesc",
                    "min-width": "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "耗材名称",
                    prop: "changeAssetNames",
                    "min-width": "120",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "入库日期",
                    prop: "changeDate",
                    "min-width": "160"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "入库数量",
                    prop: "count",
                    "min-width": "100"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "经办人",
                    prop: "operatorUserName",
                    "min-width": "160",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "操作",
                    fixed: "right",
                    width: "120"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_link, {
                            type: "primary",
                            onClick: ($event: any) => (recordDetail(row,_unref(fixed_asset_change_type_rk)))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "max-height"])), [
                [_directive_loading, _unref(MI_identify)]
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_pagination, {
                  disabled: _unref(MI_identify),
                  background: "",
                  small: "",
                  total: _unref(MI_total),
                  currentPage: _unref(page),
                  "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
                  "page-size": _unref(size),
                  "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
                  class: "mt-10",
                  "page-sizes": [10, 30, 50, 100, 300, 1000],
                  layout: "sizes, prev, pager, next, total, jumper",
                  onCurrentChange: _unref(MI_pageChange),
                  onSizeChange: _unref(MI_sizeChange)
                }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["name"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})